import Tab from "../tabs/tab"
export default Tab
